module.exports = __webpack_public_path__ + "img/blibli.30b0bfd2.png";